import { Controller } from "@hotwired/stimulus"

// This controller will submit a patch request when a checkbox is clicked.
// The checkbox will have a pathValue that is the path to the resource
// to be patched when the updateRemote method is called.  The name
// of the checkbox will be the name of the attribute to be updated, which
// for Rails will be model[attribute].  The checked property of the
// checkbox will be updated when the fetch finishes just in case something
// goes wrong and the checkbox is not updated on the server.

// Connects to data-controller="checkbox-submitter"
export default class extends Controller {
  static values = { path: String }

  connect() {
  }

  updateRemote(event) {
    const checkbox = event.target
    const name = checkbox.name
    const md = name.match(/^(\w+)\[(\w+)\]$/)
    if (!md) {
      throw new Error("Checkbox name must be of the form model[attribute]")
    }
    const model = md[1]
    const attribute = md[2]
    const value = checkbox.checked ? 1 : 0
    const data = new FormData()
    data.append(name, value)
    const csrfToken = document.getElementsByTagName('meta')['csrf-token'].content;
    fetch(this.pathValue, {
      method: "PATCH",
      body: data,
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }
      return response.json()
    }).then(data => {
      checkbox.checked = data[attribute]
    }).catch(error => {
      alert("There has been a problem updating the checkbox: ", error)
      checkbox.checked = !checkbox.checked
    })
  }
}
